import CoverManage from './CoverManage'
import withCoverManage from './withCoverManage'

const ConnectedCoverManage = withCoverManage(CoverManage)

export { ConnectedCoverManage as CoverManage }
